import { render, staticRenderFns } from "./GRUserSelector.vue?vue&type=template&id=5649c00b&"
import script from "./GRUserSelector.vue?vue&type=script&lang=js&"
export * from "./GRUserSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports